import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "upgrade-module" }
const _hoisted_2 = { class: "upgrade-module-environment-title" }
const _hoisted_3 = { class: "upgrade-module-environment-content" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "upgrade-module-version-item-slide" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "upgrade-module-version-label" }, " 版本号 ", -1)
const _hoisted_7 = { class: "upgrade-module-version-value" }
const _hoisted_8 = {
  key: 0,
  class: "new-version-tag",
  color: "#F5222D"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "upgrade-module-branch-label" }, " 所属分支 ", -1)
const _hoisted_10 = { class: "upgrade-module-branch-value" }
const _hoisted_11 = { class: "upgrade-module-version-tools" }
const _hoisted_12 = { class: "upgrade-module-version-item-detail" }
const _hoisted_13 = { class: "upgrade-module-detail" }
const _hoisted_14 = {
  class: "upgrade-module-detail-item",
  label: "提交人"
}
const _hoisted_15 = {
  class: "upgrade-module-detail-item",
  label: "提交时间"
}
const _hoisted_16 = {
  key: 0,
  class: "upgrade-module-detail-item",
  label: "版本状态",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_17 = {
  key: 1,
  class: "upgrade-module-detail-item",
  label: "检验不通过理由"
}
const _hoisted_18 = {
  class: "upgrade-module-detail-item",
  label: "MD5"
}
const _hoisted_19 = {
  class: "upgrade-module-detail-item",
  label: "更新内容"
}
const _hoisted_20 = { class: "upgrade-module-version-item-tools" }
const _hoisted_21 = { style: {"display":"block","font-size":"22px","padding-bottom":"20px","text-align":"center"} }

import QRCode from '@/components/version-manage/component/QRCode.vue';
import { ProductDetailInfo, VersionItem } from '@/@types/version-manage/Product';
import { useProduct } from '@/modules/version-manage';
import { createVNode, inject, reactive, toRefs, h } from 'vue';
import { message, Modal } from 'ant-design-vue';
import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
import { downLoadFileByUrl } from '@/tools/common';
import { get, post } from '@/lib/api';
import { useVersionDetail } from '@/modules/version-manage/useVersionDetail';
import { submitCheck, auditCheck } from '@/api/version-manage';
import { state as globalState, service as globalService } from '@/modules/global';

interface IProps {
  /** 项目详情信息 */
  productDetailInfo: ProductDetailInfo;
  /** 版本列表 */
  versionList: VersionItem[];
  /** 仅显示正式（医疗器械要求） */
  onlyprod: boolean;
}

interface IEmit {
  (e: 'onVersionInfoUpdate'): void; // 版本信息更新成功
  (e: 'onLoading', value: boolean): void; // 正在请求
  (e: 'onStagedVersionPublished', value: { versionId: number; data: any }): void; // 预发布版本发布成功
}


export default /*#__PURE__*/_defineComponent({
  __name: 'VersionUpgradeModuleProd',
  props: {
    productDetailInfo: null,
    versionList: null,
    onlyprod: { type: Boolean }
  },
  emits: ["onVersionInfoUpdate", "onLoading", "onStagedVersionPublished"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'onVersionInfoUpdate'): void; // 版本信息更新成功
  (e: 'onLoading', value: boolean): void; // 正在请求
  (e: 'onStagedVersionPublished', value: { versionId: number; data: any }): void; // 预发布版本发布成功
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  /** 项目详情信息 */
  productDetailInfo: ProductDetailInfo;
  /** 版本列表 */
  versionList: VersionItem[];
  /** 仅显示正式（医疗器械要求） */
  onlyprod: boolean;
};



const { productDetailInfo } = toRefs(props);
const productStore = useProduct();

const qrCodeState = reactive({
  currentVersion: {} as VersionItem,
  visibleQRCode: false,
});

const state = reactive({
  /** Jenkins构建进度 */
  buildPercent: 0,
  /** 重试的版本id */
  id: 0,
  /** 是否构建完成 */
  isBuildComplete: false,
  /** 任务启动时间 */
  timestamp: 0,
  /** 上次构建预估时间 */
  estimatedDuration: 0,
  /** 是否显示拒绝理由框 */
  visibleRejectReason: false,
  /** 拒绝理由 */
  rejectReason: '',
  /** 拒绝的版本Id */
  rejectVersionId: -1,
});

// 质检状态 1:待编辑 2:已编辑 3:待质检 4:质检已通过 5:质检未通过

/** 发布环境 */
const environmentVersionStr = [
  { id: 1, state: undefined, code: 'production', txt: '正式发布', permission: ['system:version:formal:release'] },
  { id: 2, state: [4], code: 'staging', txt: '待正式发布', permission: ['system:version:formal:release'] },
  { id: 3, state: [3], code: 'staging', txt: '质检阶段', permission: ['system:version:quality:inspection:audit'] },
  { id: 4, state: [5, 1, 2], code: 'staging', txt: '编辑软件信息', permission: ['system:version:quality:inspection'] },
];

/** 版本状态 */
const propState = [
  { text: '', status: 'default', color: '#1890FF' },
  { text: '待编辑', status: 'processing', color: '#1890FF' },
  { text: '待质检', status: 'warning', color: '#1890FF' },
  { text: '待质检', status: 'warning', color: '#1890FF' },
  { text: '质检已通过', status: 'success', color: '#52C41A' },
  { text: '质检未通过', status: 'error', color: '#FF4D4F' },
];

/** 判断当前用户是否有权限 */
const hasPermission = (permissions: string[]) => {
  const all_permission = '*:*:*';
  const getPermissions = globalState.permissions;

  if (permissions && permissions?.length > 0) {
    const permissionFlag = permissions;

    return getPermissions.some(permission => {
      return all_permission === permission || permissionFlag.includes(permission);
    });
  }
  return true;
};

/** 根据环境及发布状态获取项目迭代版本 */
const getVersionByEnvironment = (environment: string, versionProdStates: number[] | undefined) => {
  if (!props.versionList?.length) return [];
  return props.versionList.filter(
    i => i.environment === environment && (!versionProdStates || versionProdStates.includes(i.qualityInspectionStatus)),
  );
};

/** 显示二维码 */
const showQRCode = (versionInfo: VersionItem) => {
  qrCodeState.currentVersion = versionInfo;
  qrCodeState.visibleQRCode = true;
};

/** 获取状态值 */
const getState = (version: VersionItem) => {
  if (version.build === false) return 'build-fail';
  else if (version.publishState === 'timeout') return 'time-out';
  else if (version.publishState === 'silent_timeout') return 'silent-timeout';
  else if (!version.build) return 'building';
  else if (!version.enable) return 'not-enable';
  return version.publishState;
};

/** 提交质检检测 */
const submitOfCheck = item => {
  if ([1, 5].includes(item.qualityInspectionStatus)) {
    message.warn('请先编辑软件信息后提交质检');
    return;
  }
  const hide = message.loading('正在提交...');
  submitCheck(item.id)
    .then(d => {
      emit('onVersionInfoUpdate');
    })
    .catch(err => {
      message.error('提交到质检异常，请联系管理员');
    })
    .finally(() => {
      hide();
    });
};

/** 检验通过（需要填写理由则到第二部分） */
const auditOfCheck_1 = (item: Record<string, any>, pass: boolean) => {
  if (pass) {
    const hide = message.loading('正在提交...');
    auditCheck(item.id, true)
      .then(d => {
        emit('onVersionInfoUpdate');
        message.success('已提交到待正式发布阶段');
      })
      .catch(err => {
        message.error('提交到质检异常，请联系管理员');
      })
      .finally(() => {
        hide();
      });
  } else {
    state.rejectVersionId = item.id;
    state.rejectReason = '';
    state.visibleRejectReason = true;
  }
};
/** 检验拒绝 */
const auditOfCheck_2 = () => {
  if (!state.rejectReason) {
    message.warn('请输入检验不通过理由');
    return;
  }
  const hide = message.loading('正在提交...');
  auditCheck(state.rejectVersionId, false, state.rejectReason)
    .then(d => {
      state.rejectVersionId = -1;
      state.rejectReason = '';
      state.visibleRejectReason = false;
      emit('onVersionInfoUpdate');
      message.success('已退回到编辑软件信息阶段');
    })
    .catch(err => {
      message.error('提交到质检异常，请联系管理员');
    })
    .finally(() => {
      hide();
    });
};

/** 删除非正式版本 */
const removeVersion = (versionInfo: VersionItem) => {
  Modal.confirm({
    title: `警告`,
    icon: createVNode(ExclamationCircleOutlined),
    content: createVNode(
      'div',
      { style: 'color:red;' },
      `是否删除${productStore.environment[versionInfo.environment]}的${versionInfo.version}版本？`,
    ),
    onOk: () => {
      const hide = message.loading('版本删除中...');
      get(`/system/program/ver/version/remove?id=${versionInfo.id}`)
        .then(() => {
          emit('onVersionInfoUpdate');
          message.success('版本删除成功');
        })
        .finally(() => {
          hide();
        });
    },
  });
};

/** 退回到上一版本 */
const undoVersion = (versionInfo: Record<string, any>) => {
  Modal.confirm({
    title: `警告`,
    icon: createVNode(ExclamationCircleOutlined),
    content: createVNode('div', { style: 'color:red;' }, `是否将${versionInfo.version}正式版本退回到上一版本？`),
    onOk: () => {
      const hide = message.loading('版本退回中...');
      get(`/system/program/ver/version/back?versionId=${versionInfo.id}`)
        .then(() => {
          emit('onVersionInfoUpdate');
          message.success('版本退回成功');
        })
        .finally(() => {
          hide();
        });
    },
  });
};

/** 发布预发布版本 */
const publishStagingVersion = (versionId: number) => {
  Modal.confirm({
    content: '是否发布到预发布环境？',
    icon: createVNode(ExclamationCircleOutlined),
    onOk: () => {
      emit('onLoading', true);
      const hide = message.loading('正在发布到预发布环境...');
      post('/system/program/ver/version/pre/release', {
        versionId,
      })
        .then(d => {
          emit('onVersionInfoUpdate');
          emit('onStagedVersionPublished', {
            versionId,
            data: d,
          });
        })
        .finally(() => {
          emit('onLoading', false);
          hide();
        });
    },
    okText: '确认发布',
    cancelText: '取消',
    onCancel() {
      Modal.destroyAll();
    },
  });
};

/** 发布正式版本 */
const publishProdVersion = (versionId: number) => {
  Modal.confirm({
    content: '是否正式发布？',
    icon: createVNode(ExclamationCircleOutlined),
    onOk: () => {
      emit('onLoading', true);
      const hide = message.loading('正在发布中...');
      post('/system/program/ver/version/formal/release', {
        versionId,
      })
        .then(() => {
          message.success('已正式发布');
          emit('onVersionInfoUpdate');
        })
        .finally(() => {
          emit('onLoading', false);
          hide();
        });
    },
    okText: '确认发布',
    cancelText: '取消',
    onCancel() {
      Modal.destroyAll();
    },
  });
};

/** 点击子菜单 */
const handleMenuClick = ({ key }, versionInfo: VersionItem) => {
  switch (key) {
    case 'publish':
      publishProdVersion(versionInfo.id);
      break;
    case 'check':
      publishStagingVersion(versionInfo.id);
      break;
    case 'remove':
      removeVersion(versionInfo);
      break;
    case 'download':
      downLoadFileByUrl(versionInfo.storageKey);
      break;
    case 'undo':
      undoVersion(versionInfo);
      break;
    default:
      break;
  }
};
const { versionDetailState, toogleVersionDetailModal, onVersionDetailChange, showAppVersionDetail, editAppVersionDetail } = inject(
  'useVersionDetail',
) as ReturnType<typeof useVersionDetail>;

return (_ctx: any,_cache: any) => {
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_qrcode_outlined = _resolveComponent("qrcode-outlined")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_badge = _resolveComponent("a-badge")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_VersionDetailEditorModal = _resolveComponent("VersionDetailEditorModal")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _directive_hasPermi = _resolveDirective("hasPermi")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(environmentVersionStr.filter(i => hasPermission(i.permission)), (environment) => {
      return (_openBlock(), _createElementBlock("div", {
        key: environment.id,
        class: "upgrade-module-environment"
      }, [
        _createElementVNode("label", _hoisted_2, _toDisplayString(environment.txt), 1),
        _createElementVNode("div", _hoisted_3, [
          (!getVersionByEnvironment(environment.code, environment.state).length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_a_empty, {
                  image: _unref(productStore).simpleImage,
                  description: `未提交${environment.txt}`
                }, null, 8, ["image", "description"])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getVersionByEnvironment(environment.code, environment.state), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.id,
              class: "upgrade-module-version-item"
            }, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  _createTextVNode(_toDisplayString(item.version) + " ", 1),
                  (
                  item.environment === 'production' &&
                  _unref(productDetailInfo)?.productVersionVoList?.find?.(i => i.branchId == item.branchId && i.version === item.version) &&
                  index === _unref(productDetailInfo)?.productVersionVoList.length - 1
                )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, " new "))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, _toDisplayString(item.programVerProductBranch.branchName), 1),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_a_tag, {
                    color: "blue",
                    style: {"cursor":"pointer"},
                    onClick: ($event: any) => (showQRCode(item))
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_qrcode_outlined)
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode("二维码")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("ul", _hoisted_13, [
                  _createElementVNode("li", _hoisted_14, _toDisplayString(item.createBy), 1),
                  _createElementVNode("li", _hoisted_15, _toDisplayString(item.createTime || '——'), 1),
                  (propState[item.qualityInspectionStatus])
                    ? (_openBlock(), _createElementBlock("li", _hoisted_16, [
                        _createVNode(_component_a_badge, {
                          status: propState[item.qualityInspectionStatus].status,
                          text: propState[item.qualityInspectionStatus].text
                        }, null, 8, ["status", "text"])
                      ]))
                    : _createCommentVNode("", true),
                  ([1, 5].includes(item.qualityInspectionStatus))
                    ? (_openBlock(), _createElementBlock("li", _hoisted_17, _toDisplayString(item.qualityInspectionDescription), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("li", _hoisted_18, _toDisplayString(item.md5 || '——'), 1),
                  _createElementVNode("li", _hoisted_19, [
                    _createElementVNode("pre", null, _toDisplayString(item.updateContent), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                (environment.code === 'production')
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 0,
                      type: "default",
                      style: {"vertical-align":"bottom","margin-right":"10px"},
                      onClick: ($event: any) => (_unref(showAppVersionDetail)(item.id))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 查看软件信息 ")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : (environment.code === 'staging' && item.qualityInspectionStatus === 4)
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 1,
                        type: "primary",
                        style: {"vertical-align":"bottom","margin-right":"10px"},
                        onClick: ($event: any) => (publishProdVersion(item.id))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 正式发布 ")
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : (environment.code === 'staging' && item.qualityInspectionStatus === 3)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createVNode(_component_a_button, {
                            type: "default",
                            style: {"vertical-align":"bottom","margin-right":"10px"},
                            onClick: ($event: any) => (_unref(showAppVersionDetail)(item.id))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 查看软件信息 ")
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_component_a_button, {
                            type: "primary",
                            style: {"vertical-align":"bottom","margin-right":"10px"},
                            onClick: ($event: any) => (auditOfCheck_1(item, true))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 检验通过 ")
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_component_a_button, {
                            type: "primary",
                            danger: "",
                            style: {"vertical-align":"bottom"},
                            onClick: ($event: any) => (auditOfCheck_1(item, false))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 检验不通过 ")
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ], 64))
                      : (environment.code === 'staging' && [5, 1, 2].includes(item.qualityInspectionStatus))
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                            _createVNode(_component_a_button, {
                              type: "default",
                              style: {"vertical-align":"bottom","margin-right":"10px"},
                              onClick: ($event: any) => (_unref(showAppVersionDetail)(item.id))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" 查看软件信息 ")
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                              type: item.qualityInspectionStatus === 2 ? 'default' : 'primary',
                              style: {"vertical-align":"bottom","margin-right":"10px"},
                              onClick: ($event: any) => (_unref(editAppVersionDetail)(item.versionData, item.id))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" 编辑软件信息 ")
                              ]),
                              _: 2
                            }, 1032, ["type", "onClick"])), [
                              [_directive_hasPermi, ['system:project:edit']]
                            ]),
                            _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                              type: "primary",
                              style: {"vertical-align":"bottom","margin-right":"10px"},
                              onClick: ($event: any) => (submitOfCheck(item))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" 提交质检检测 ")
                              ]),
                              _: 2
                            }, 1032, ["onClick"])), [
                              [_directive_hasPermi, ['system:project:edit']]
                            ])
                          ], 64))
                        : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ])
      ]))
    }), 128)),
    _createVNode(_component_a_modal, {
      visible: qrCodeState.visibleQRCode,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((qrCodeState.visibleQRCode) = $event)),
      "body-style": { padding: '0px' },
      footer: null,
      width: 300,
      title: "二维码"
    }, {
      default: _withCtx(() => [
        _createVNode(QRCode, {
          width: 300,
          height: 300,
          margin: 0,
          value: qrCodeState.currentVersion.storageKey
        }, null, 8, ["value"]),
        _createElementVNode("div", _hoisted_21, "v" + _toDisplayString(qrCodeState.currentVersion.version), 1)
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_VersionDetailEditorModal, {
      "version-data": _unref(versionDetailState).currentVersionData,
      visible: _unref(versionDetailState).VersionDetailmodalVisible,
      "project-id": _unref(productDetailInfo).id,
      onOnCancel: _unref(toogleVersionDetailModal),
      onOnSubmit: _unref(onVersionDetailChange)
    }, null, 8, ["version-data", "visible", "project-id", "onOnCancel", "onOnSubmit"]),
    _createVNode(_component_a_modal, {
      visible: state.visibleRejectReason,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((state.visibleRejectReason) = $event)),
      width: 500,
      title: "检验不通过理由",
      onOk: auditOfCheck_2
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_textarea, {
          value: state.rejectReason,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((state.rejectReason) = $event)),
          placeholder: "请输入检验不通过理由",
          "show-count": "",
          maxlength: 100
        }, null, 8, ["value"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})